module.exports = __webpack_public_path__ + "img/11.c7203631.jpg";